// 环境切换参数 dev: 开发环境, production: 生产环境
const env = process.env.NODE_ENV
console.log('env',env)
const planform = 'pc'

const profileMap = {
  //dev => development
  dev: {
    host: 'https://misapitest.cnmrms.com',
    pcHost: 'http://192.168.1.14:5000/'
  },
  test: {
    host: 'https://misapitest.cnmrms.com',
    pcHost: 'https://adkstest.cnmrms.com'
  },
  production: {
    host: 'https://misapi.cnmrms.com',
    pcHost: 'https://adks.cnmrms.com'
  },
  debug: {
    host: 'https://misapi.cnmrms.com',
    pcHost: 'https://adks.cnmrms.com'
  }
}

module.exports = {
  env,
  profile: profileMap[env],
  planform
}
